define('core/utils',['require'],function (require) {
	'use strict';

	// [Elvis Chan]: private variables
	var utils = {};

	utils.capitalize = function (word) {

		if (!_.isEmpty(word)) {

			return word[0].toUpperCase() + word.slice(1);
		}
	};

	utils.extend = function (protoProps, staticProps) {

		var that = this;
		var child;

		if (protoProps && _.has(protoProps, 'constructor')) {

			child = protoProps.constructor;

		} else {

			child = function () {

				return that.apply(this, arguments);
			};
		}

		_.extend(child, that, staticProps);

		var Surrogate = function () {

			this.constructor = child;
		};

		Surrogate.prototype = that.prototype;

		child.prototype = new Surrogate();

		if (protoProps) {

			_.extend(child.prototype, protoProps);
		}

		child.__super__ = that.prototype;

		return child;
	};

	utils.generateSelector = function (selectors) {

		var $selectors = {};

		_.each(selectors, function (selector, key) {

			$selectors[key] = $(selector);
		});

		return $selectors;
	};
	
	utils.getBoolean = function (data) {

		return (String(data).toLowerCase() === 'true');
	};
	
	utils.getQueryString = function () {

		var queryString = window.location.search.substr(1).split('&');

		if (_.isEmpty(queryString)) {

			return {};
		}

		var obj = {};

		for (var i = 0; i < queryString.length; ++i) {

			var param = queryString[i].split('=');

			if (param.length !== 2) {
				
				continue;
			}

			obj[param[0]] = decodeURIComponent(param[1].replace(/\+/g, ' '));
		}

		return obj;
	};

	utils.getRandomNum = function (maxRange, minRange) {

		minRange = (_.isUndefined(minRange)) ? 1 : minRange;

		return Math.floor((Math.random() * maxRange) + minRange);
	};

	utils.humanize = function (words) {

		var _words = words || '';
		var wordArray = _words.split('-');

		for (var i = 0; i < wordArray.length; i++) {

			wordArray[i] = this.capitalize(wordArray[i]);
		}

		return wordArray.join('');
	};

	utils.isEmailFormat = function (email) {

		var regex = new RegExp([
			'^([\w-]+(?:\.[\w-]+)*)',
			'@((?:[\w-]+\.)*\w[\w-]{0,66})',
			'\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i'
		].join(''));
		
		return regex.test(email);
	};

	utils.jsonDecode = function (data) {

		return $.parseJSON(data);
	};

	utils.jsonEncode = function (data) {

		return JSON.stringify(data);
	};

	utils.scrollTop = function (position) {

		$('html, body').animate({
			scrollTop: position
		}, 300, 'swing');
	};

	utils.serializeObject = function ($form) {

		var o = {};
		var a = $form.serializeArray();

		$.each(a, function () {

			if (o[this.name]) {

				if (!o[this.name].push) {

					o[this.name] = [ o[this.name] ];
				}

				o[this.name].push(this.value || '');

			} else {

				o[this.name] = this.value || '';
			}
		});

		return o;
	};

	return utils;
});
